module.exports = __webpack_public_path__ + "static/VSsnippetcover-866e2bfe4b8e39d26f5fd27cc6ed7b5e.png";